(function () {
  'use strict';

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    /*
     * Core Gi desktop structure: commerce stays in the right rail while the
     * accordions, attribute icons and key features continue below the gallery.
     * Restore the original DOM positions on mobile so its established content
     * order remains unchanged.
     */
    var desktopDetails = root.querySelector('[data-jjt-desktop-details]');
    var responsiveModules = [
      root.querySelector('.jjt-updp__accordions'),
      root.querySelector('.jjt-updp__icon-strip'),
      root.querySelector('.jjt-updp__features'),
      root.querySelector('.jjt-updp__performance')
    ].filter(Boolean).map(function (node) {
      return { node: node, parent: node.parentNode, next: node.nextSibling };
    });
    var desktopQuery = window.matchMedia('(min-width:961px)');

    function placeDetailModules() {
      if (!desktopDetails) return;
      if (desktopQuery.matches) {
        responsiveModules.forEach(function (item) { desktopDetails.appendChild(item.node); });
        return;
      }
      responsiveModules.slice().reverse().forEach(function (item) {
        if (item.next && item.next.parentNode === item.parent) item.parent.insertBefore(item.node, item.next);
        else item.parent.appendChild(item.node);
      });
    }
    placeDetailModules();
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', placeDetailModules);
    else desktopQuery.addListener(placeDetailModules);

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-jjt-slide]'));
    var indexNode = root.querySelector('[data-jjt-gallery-index]');
    var current = 0;
    function setSlide(next) {
      if (!slides.length) return;
      current = (next + slides.length) % slides.length;
      slides.forEach(function (slide, index) { slide.classList.toggle('is-active', index === current); });
      if (indexNode) indexNode.textContent = String(current + 1);
    }
    var previous = root.querySelector('[data-jjt-gallery-prev]');
    var next = root.querySelector('[data-jjt-gallery-next]');
    if (previous) previous.addEventListener('click', function () { setSlide(current - 1); });
    if (next) next.addEventListener('click', function () { setSlide(current + 1); });

    var track = root.querySelector('[data-jjt-gallery-track]');
    var touchStart = 0;
    if (track) {
      track.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (event) {
        var distance = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(distance) > 45) setSlide(current + (distance < 0 ? 1 : -1));
      }, { passive: true });
    }

    var form = root.querySelector('#JjtUniversalProductForm');
    var select = root.querySelector('[data-jjt-variant-select]');
    var variantValue = root.querySelector('[data-jjt-variant-value]');
    var input = root.querySelector('[data-jjt-variant-input]');
    var price = root.querySelector('[data-jjt-price]');
    var add = root.querySelector('[data-jjt-atc]');
    var mobileAdd = root.querySelector('[data-jjt-mobile-atc]');
    var mobilePrice = root.querySelector('[data-jjt-mobile-price]');
    var mobileSelect = root.querySelector('[data-jjt-mobile-variant-select]');
    var notify = root.querySelector('[data-jjt-notify-modal]');
    var sizeTrigger = root.querySelector('[data-jjt-size-trigger]');
    var sizes = root.querySelector('[data-jjt-sizes]');
    var sizeOptions = root.querySelectorAll('[data-jjt-size-option]');

    function suppressInjectedNotify() {
      if (!form) return;
      form.querySelectorAll('a, button, [role="button"]').forEach(function (node) {
        if (node === add || node.closest('[data-jjt-notify-modal]')) return;
        var signal = [node.className, node.id, node.getAttribute('data-testid'), node.textContent].join(' ');
        if (!/NOTIFY ME|BACK IN STOCK|KLAVIYO.*BIS|BIS.*KLAVIYO/i.test(signal)) return;
        node.setAttribute('aria-hidden', 'true');
        node.setAttribute('tabindex', '-1');
        node.style.setProperty('display', 'none', 'important');
      });
    }

    function selectedOption() {
      return select && select.options[select.selectedIndex];
    }
    function closeSizes() {
      if (!sizes || !sizeTrigger) return;
      sizes.classList.remove('is-open');
      sizeTrigger.setAttribute('aria-expanded', 'false');
    }
    function syncVariant() {
      var option = selectedOption();
      if (!option) return;
      if (input) input.value = option.value;
      if (variantValue) {
        variantValue.textContent = select.options.length === 1 ? option.textContent.trim() : 'Size: ' + option.textContent.trim();
      }
      if (price) price.textContent = money(option.dataset.price);
      if (mobilePrice) mobilePrice.textContent = money(option.dataset.price);
      var available = option.dataset.available === 'true';
      var preorder = option.dataset.preorder === 'true';
      var label = available ? (preorder ? 'Pre-order' : 'Add to bag') : 'Notify me';
      if (add) {
        add.textContent = label;
        add.dataset.notify = available ? 'false' : 'true';
        if (available) add.style.removeProperty('display');
        else {
          add.disabled = false;
          add.style.setProperty('display', 'block', 'important');
        }
      }
      if (mobileAdd) mobileAdd.textContent = label;
      if (mobileSelect && mobileSelect.value !== option.value) mobileSelect.value = option.value;
      var installment = root.querySelector('.jjt-updp__installment strong');
      if (installment) installment.textContent = money(Number(option.dataset.price) / 4);
      sizeOptions.forEach(function (button) {
        var active = String(button.dataset.variantId) === String(option.value);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      suppressInjectedNotify();
    }
    if (add && window.MutationObserver) {
      new MutationObserver(function () {
        if (add.dataset.notify !== 'true' || add.style.display !== 'none') return;
        add.style.setProperty('display', 'block', 'important');
      }).observe(add, { attributes: true, attributeFilter: ['style'] });
    }
    if (form && window.MutationObserver) {
      new MutationObserver(suppressInjectedNotify).observe(form, { childList: true, subtree: true });
    }
    if (select) select.addEventListener('change', syncVariant);
    if (mobileSelect) {
      mobileSelect.addEventListener('change', function () {
        if (!select) return;
        select.value = mobileSelect.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (sizeTrigger && sizes) {
      sizeTrigger.addEventListener('click', function () {
        var open = !sizes.classList.contains('is-open');
        sizes.classList.toggle('is-open', open);
        sizeTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      sizeOptions.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!select) return;
          select.value = button.dataset.variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          closeSizes();
        });
      });
      document.addEventListener('click', function (event) {
        if (!sizes.classList.contains('is-open')) return;
        if (sizes.contains(event.target) || sizeTrigger.contains(event.target)) return;
        closeSizes();
      });
      sizeTrigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeSizes();
        sizeTrigger.focus();
      });
    }
    syncVariant();

    function openNotify() {
      if (!notify) return;
      notify.classList.add('is-open');
      notify.setAttribute('aria-hidden', 'false');
      var email = notify.querySelector('input[type=email]');
      if (email) window.setTimeout(function () { email.focus(); }, 50);
    }
    function closeNotify() {
      if (!notify) return;
      notify.classList.remove('is-open');
      notify.setAttribute('aria-hidden', 'true');
    }
    root.querySelectorAll('[data-jjt-notify-close]').forEach(function (button) { button.addEventListener('click', closeNotify); });
    var notifyForm = root.querySelector('[data-jjt-notify-form]');
    if (notifyForm) {
      notifyForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var message = notifyForm.parentElement.querySelector('[data-jjt-notify-message]');
        var email = notifyForm.querySelector('input[type="email"]');
        var submit = notifyForm.querySelector('button[type="submit"]');
        var option = selectedOption();
        if (!email || !email.validity.valid || !option) {
          if (email) email.reportValidity();
          return;
        }
        if (message) message.textContent = 'Submitting…';
        if (submit) submit.disabled = true;
        var body = new URLSearchParams({
          a: 'S5XVBX',
          email: email.value.trim(),
          variant: option.value,
          platform: 'shopify'
        });
        window.fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        })
          .then(function () {
            if (message) message.textContent = 'You’re on the list. We’ll email you when it’s back.';
            notifyForm.reset();
          })
          .catch(function () {
            if (message) message.textContent = 'Please try again in a moment.';
          })
          .finally(function () {
            if (submit) submit.disabled = false;
          });
      });
    }

    function addToBag(event) {
      if (event) event.preventDefault();
      var option = selectedOption();
      if (!option || option.dataset.available !== 'true') {
        openNotify();
        return;
      }
      if (add) {
        add.disabled = true;
        add.textContent = 'Adding…';
      }
      var data = new FormData(form);
      window.fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add this item.');
          return response.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('jjt:cart:added', { detail: item }));
        })
        .catch(function (error) {
          window.alert(error.message || 'Unable to add this item.');
        })
        .finally(function () {
          if (add) add.disabled = false;
          syncVariant();
        });
    }
    if (form) form.addEventListener('submit', addToBag);
    if (mobileAdd) mobileAdd.addEventListener('click', addToBag);

    var sizeToggle = root.querySelector('[data-jjt-size-chart-toggle]');
    var sizeChart = root.querySelector('[data-jjt-size-chart]');
    var sizeChartAction = root.querySelector('[data-jjt-size-chart-action]');
    if (sizeToggle && sizeChart) {
      sizeToggle.addEventListener('click', function () {
        var open = sizeChart.classList.toggle('is-open');
        sizeToggle.textContent = open ? 'Close size chart' : 'Open size chart';
      });
    }
    if (sizeChartAction) {
      sizeChartAction.addEventListener('click', function () {
        closeSizes();
        var sizeFit = root.querySelector('[data-jjt-size-fit]');
        if (sizeFit) sizeFit.open = true;
        if (sizeChart && !sizeChart.classList.contains('is-open')) {
          sizeChart.classList.add('is-open');
          if (sizeToggle) sizeToggle.textContent = 'Close size chart';
        }
        if (sizeFit) sizeFit.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var mobileMenu = root.querySelector('[data-jjt-mobile-menu]');
    if (mobileMenu) {
      mobileMenu.addEventListener('click', function () {
        var globalMenuButton = document.querySelector('[data-jjt-dock-menu]');
        if (globalMenuButton) globalMenuButton.click();
      });
    }
  }

  function start() {
    document.querySelectorAll('[data-jjt-updp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
